import React,{ ReactNode, Suspense, useEffect } from 'react';
import type { FC, LazyExoticComponent } from 'react';
import { useAppSelector } from '@/redux/hooks';
import { goLogin } from '@/utils/index';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';
import {
  useLocation,
  Navigate,
  useParams,
} from "react-router-dom";
interface ILazyWrapperParams {
  Component: LazyExoticComponent<FC<any>>
  callback?: ReactNode
  classStr?: string
}

// 异步加载组件包装
export const LazyWrapper = ({Component, callback, classStr}: ILazyWrapperParams) => {
  return (
    <Suspense fallback={callback ? callback : <div className={classStr ? classStr : 'loading-content-bg'}> <Spin size="large"/></div>}>
      <Component/>
    </Suspense>
  );
};

// 需要登录组件包装
export const RequireAuth = ({ children }:{ children: React.ReactElement }) => {
  const { loginStatus, completed } = useAppSelector(state => state.user);
  useEffect(() => {
    if (completed && !loginStatus) {
      goLogin()
    }
  }, [loginStatus, completed])
  return (
    <>
      {children}
    </>
  );
  
};
export interface IMetaTitle {
  children: React.ReactNode
  title: string
}
export const MetaTitle = ({children, title}: IMetaTitle) => {
  const { t } = useTranslation('documentTitle')
  useEffect(() => {
    document.title = t(title)
  })
  return (
    <>
      {children}
    </>
  )
}


export const QuantumVmRedirect: FC<any> = () => {
  const { type, id, chipId } = useParams();
  const { language } = useAppSelector((state) => state.common);
  if (!type || !id) {
    return <Navigate to={`/${language}`} />
  }
  const changeChipId = (chipId && chipId !== '72' && id === '0') ? '72' : chipId;
  return (
    <Navigate to={`/${language}/computerServices/quantumVm/${type}/${id}${chipId ? `/${changeChipId}` : '' }`}  />
  )
}

export const ComputerServicesRedirect: FC<any> = () => {
  // const { language } = useAppSelector((state) => state.common);
  // const { loginStatus } = useAppSelector(state => state.user);
  const { pathname } = window.location
  // const url = `${process.env.REACT_APP_WORKBENCH_URL}${language}/computerServices/${loginStatus ? 'dashboard': 'services'}`
  const host = process.env.REACT_APP_WORKBENCH_URL?.slice(0,-1) // 去掉斜杠/
  const url = `${host}${pathname}`
  window.location.href = url
  return <div></div>
  // return <Route element={() => { window.location.href = url; return <div></div> }} />
  // return <Navigate to={`${window.location.pathname.replace('/computerServies/servies','/computerServices/services').replace('/computerServies/','/computerServices/')}${window.location.search}`} />
}

export const LanguageRedirect: FC<any> = () => {
  const location = useLocation()
  const { pathname, search } = location
  const language = useAppSelector(state => state.common.language)
  return <Navigate to={`/${language}${pathname}${search}`} />
}
